import sickBabyBackground from '@assets/images/sick_baby_background.png';
import BackgroundImage from '@components/BackgroundImage';
import FocusableIconButton from '@components/FocusableIconButton';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { EXIT_BUTTON } from './focusKey';

import * as styles from './styles';

const Exit = () => {
  const navigate = useNavigate();

  const { focusKey, setFocus } = useFocusable();

  useEffect(() => {
    setFocus(EXIT_BUTTON);
  }, [setFocus]);

  const goBack = () => {
    navigate(-1);
  };

  return (
    <FocusContext.Provider value={focusKey}>
      <div css={styles.container}>
        <div css={styles.contentContainer}>
          <div css={styles.title}>
            <p>굿닥 비대면진료 앱을</p>
            <p>종료하시겠어요?</p>
          </div>
          <div css={styles.buttonContainer}>
            <FocusableIconButton
              onEnterPress={goBack}
              iconType="cancel"
              buttonStyle={styles.button}
            >
              취소
            </FocusableIconButton>
            <FocusableIconButton
              focusKey={EXIT_BUTTON}
              onEnterPress={() => {
                window.close();
              }}
              iconType="arrow"
              buttonStyle={styles.button}
            >
              종료
            </FocusableIconButton>
          </div>
        </div>
        <BackgroundImage url={sickBabyBackground} filter={'blur(20px)'} />
      </div>
    </FocusContext.Provider>
  );
};

export default Exit;
